import { Tooltip } from "components/tooltip";
import { Text } from "components/text";
import { cn } from "utils";
import type { SearchSuggestion } from "../types";

export interface SearchSuggestionItemProps extends SearchSuggestion {
  onClick: () => void;
  isSelected?: boolean;
}

export const SearchSuggestionItem = ({
  title,
  value,
  hoverText,
  onClick,
  isSelected = false,
}: SearchSuggestionItemProps) => {
  return (
    <button
      type="button"
      className={cn(
        "h-10 text-start rounded-lg text-sm text-popover-foreground transition-colors cursor-pointer px-2 py-[10px] hover:bg-search-suggestion-highlight",
        isSelected && "bg-search-suggestion-highlight",
      )}
      onClick={onClick}
    >
      <Tooltip content={hoverText} side="right">
        <div className="inline-block">
          <Text
            as="span"
            variant="bodyStrong"
            className="inline-block max-w-lg truncate"
          >
            {title}
          </Text>
          <span className="inline-block max-w-lg truncate ml-1">{value}</span>
        </div>
      </Tooltip>
    </button>
  );
};
